import { ChakraProvider } from '@chakra-ui/react';
//import * as React from 'react';
import React, { useState } from 'react';

import { useEffect } from 'react';
// import React from 'react';
import { ApolloClient, InMemoryCache, ApolloProvider, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { Container } from '@chakra-ui/react';
//import Home from './pages/Home';
//import Signup from './pages/Signup';
//import Login from './pages/Login';
import Header from './components/Header';
import Footer from './components/Footer';
//import { Form } from 'react-router-dom';
import Content from './components/Content';
import './App.css';
// Construct our main GraphQL API endpoint
const httpLink = createHttpLink({
  uri: '/graphql',
});

// Construct request middleware that will attach the JWT token to every request as an `authorization` header
const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('id_token');
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const client = new ApolloClient({
  // Set up our client to execute the `authLink` middleware prior to making the request to our GraphQL API
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});




function App() {

  useEffect(() => {
    document.title = 'Gaming Geeks';
  });
  return (
    <div className="App" >

      <ApolloProvider client={client}>
        <ChakraProvider w="100%">
          
          <div id="main-content">

            <Header />
            
          </div>
          <Footer />
        </ChakraProvider>
      </ApolloProvider>

    </div >
  );
}

export default App;




